/**
 * package: com.inq.stage
 * class: ViewportMgrImplMobile
 *
 * Standard viewport implementation for ** MOBILE **;  meaning phone and tablet
 * currently viewport management is only necessary for MOBILE devices.
 *
 * @extends com.inq.stage.ViewportMgrImplBase
 * @constructor
 */
com.inq.stage.ViewportMgrImplMobile = function() {
	com.inq.stage.ViewportMgrImplBase.call(this);
	this.clientWindow = window.parent;
	this.clientDocument = this.clientWindow.document;
	this.headHtml = null;
	this.clientViewportElement = null;
	this.clientViewportContent = null;
	this.chatViewportElement = null;
	this.chatViewportClient = null;
	this.getViewportElement();
	this.isShown = false;
	this.phoneWidth = 0;
	this.restoreWidth = window.top.innerWidth;
	this.touchListener = $bind(this, this.uponTouch);
	this.resizeListener = $bind(this,this.uponResize);
	this.orientationListener = $bind(this,this.uponOrientationChange);

	/* Look for a viewport meta tag with the name of "viewport"
	 * If we do not have one, then create it and attach to head
	 */

	/** @type {NodeList} */
	var viewportList = window.top.document.getElementsByName("viewport");
	if( viewportList == null || viewportList.length == 0 ) {
		/* The width will be set to the current offsetWidth
		 * This setting gives us the same viewport width that we see on the screen
		 * So it does NOT mess up the viewport as it is without the meta tag
		 */
		if (com.inq.utils.Capabilities.isAndroid() && com.inq.utils.Capabilities.isTablet()) {
			this.restoreWidth = window.top.document.body.clientWidth;
		}
		else {
			this.restoreWidth = window.top.document.documentElement.offsetWidth;
		}

		this.createViewportElement("width=device-width");
		if (com.inq.utils.Capabilities.isAndroid() && com.inq.utils.Capabilities.isTablet()){
			this.phoneWidth = window.top.document.documentElement.clientWidth;
		}
		else {
			this.phoneWidth = window.top.document.documentElement.offsetWidth;
		}

		this.adjustViewport();
		this.restoreContent = null;
		this.clientViewportContent = null;
	} else {
		this.chatViewportClient = viewportList[0];
		this.clientViewportContent = this.chatViewportClient.content;
	}
};

$hxClasses.extend(com.inq.stage.ViewportMgrImplBase, com.inq.stage.ViewportMgrImplMobile, 'com.inq.stage.ViewportMgrImplMobile');


/**
 * createViewportElement
 *
 * @private
 * @this com.inq.stage.ViewportMgrImplMobile
 * @param {string}  content
 * @return {void}
 */
com.inq.stage.ViewportMgrImplMobile.prototype.createViewportElement = function(content) {
	if(this.chatViewportElement != null) return;
	/** @type {NodeList} */ 
	var headCollection = com.inq.ui.Container._getElementByTN("head",this.clientDocument);
	if(headCollection == null || headCollection.length < 1) return;
	this.headHtml = headCollection[0];
	if(this.chatViewportElement == null) {
		this.chatViewportElement = this.clientDocument.createElement("META");
		this.chatViewportElement.name = "viewport";
		this.chatViewportElement.id = com.inq.stage.ViewportMgr.VIEWPORT_ID;
		this.chatViewportElement.content = content;
		this.chatViewportElement.setAttribute("id",com.inq.stage.ViewportMgr.VIEWPORT_ID);
		this.chatViewportElement.setAttribute("name","viewport");
		this.chatViewportElement.setAttribute("content",content);
		this.headHtml.appendChild(this.chatViewportElement);
	}
};

/**
 * modifyViewport
 *
 * @private
 * @this com.inq.stage.ViewportMgrImplMobile
 * @param {string}  content
 * @return {void}
 */
com.inq.stage.ViewportMgrImplMobile.prototype.modifyViewport = function(content) {
	if(this.chatViewportElement != null) {
		this.chatViewportElement.name = "viewport";
		this.chatViewportElement.content = content;
		this.chatViewportElement.setAttribute("name","viewport");
		this.chatViewportElement.setAttribute("content",content);
	} else if(this.chatViewportClient != null)
		this.chatViewportClient.content = content;
};


/**
 * RestoreViewport
 *
 * @private
 * @this com.inq.stage.ViewportMgrImplMobile
 * @return {void}
 */
com.inq.stage.ViewportMgrImplMobile.prototype.RestoreViewport = function() {
	try {
		/* 	unhideLocationBar(); */
		/** @type {number} */ 
		var zoomLevel = 1;
		try {
			zoomLevel = this.phoneWidth / this.restoreWidth;
		} catch( e ) {
			haxe.Log.trace("error: " + Std.string(e),{ fileName : "ViewportMgrImplMobile.hx", lineNumber : 248, className : "com.inq.stage.ViewportMgrImplMobile", methodName : "RestoreViewport"});
			zoomLevel = 1;
		}

		if(this.chatViewportClient != null && this.clientViewportContent != null){
			this.modifyViewport(this.clientViewportContent);
		} else {
			if(zoomLevel >= 0.25 && zoomLevel <= 5) this.modifyViewport("width=device-width, initial-scale=" + zoomLevel + ", minimum-scale=0.25, maximum-scale=5, user-scalable=yes");
			else this.modifyViewport("width=" + this.restoreWidth + ", minimum-scale=0.25, maximum-scale=5, user-scalable=yes");
		}

	} catch( er ) {
		haxe.Log.trace("RestoreViewport ERROR: " + er);
	}
};


/**
 * getViewportElement
 *
 * @private
 * @this com.inq.stage.ViewportMgrImplMobile
 */
com.inq.stage.ViewportMgrImplMobile.prototype.getViewportElement = function() {
	this.clientViewportElement = null;
	/** @type {NodeList} */ 
	var viewports = this.clientDocument.getElementsByName("viewport");
	if(viewports != null && viewports.length > 0) {
		/** @type {number} */ 
		var _g1 = 0;
		/** @type {number} */ 
		var _g = viewports.length;
		while(_g1 < _g) {
			/** @type {number} */ 
			var ix1 = _g1++;
			/** @type {Element} */ 
			var el = viewports[ix1];
			if(("" + el.tagName).toLowerCase() == "meta") {
				if(el.id == com.inq.stage.ViewportMgr.VIEWPORT_ID) this.chatViewportElement = el; else this.clientViewportElement = el;
			}
		}
	}
};


/**
 * getDeviceWidth
 *
 * @private
 * @this com.inq.stage.ViewportMgrImplMobile
 * @return {number}
 */
com.inq.stage.ViewportMgrImplMobile.prototype.getDeviceWidth = function() {
	return this.clientWindow.innerWidth;
};


/**
 * getInitialWidth
 *
 * @private
 * @this com.inq.stage.ViewportMgrImplMobile
 * @return {number}
 */
com.inq.stage.ViewportMgrImplMobile.prototype.getInitialWidth = function() {
	return this.clientWindow.innerWidth;
};


/**
 * fixPositioning
 *
 * @private
 * @this com.inq.stage.ViewportMgrImplMobile
 * @return {void}
 */
com.inq.stage.ViewportMgrImplMobile.prototype.fixPositioning = function() {
	com.inq.flash.client.chatskins.ScrollMonitor.ScrollToNearTop();
	Application.application.setStyle("zoom","" + Application.initialZoom);
	this.resizeToViewport();
};


/**
 * resizeToViewport
 *
 * This code is from before MOB-375 change.
 * This calls com.inq.flash.client.chatskins.ChatTextFocusMonitor.resizeToViewport()
 *
 * TODO build its own resizeToViewport function.
 *
 * @private
 * @this com.inq.stage.ViewportMgrImplMobile
 * @return {void}
 */
com.inq.stage.ViewportMgrImplMobile.prototype.resizeToViewport = function() {
	// TODO this is original code. ViewportMgr should have its own resizeToViewport.
	com.inq.flash.client.chatskins.ChatTextFocusMonitor.resizeToViewport("ViewportMgr: fixPositioning");
};


/**
 * hide
 *
 * @override
 * @private
 * @this com.inq.stage.ViewportMgrImplMobile
 * @return {void}
 */
com.inq.stage.ViewportMgrImplMobile.prototype.hide = function() {
	if(this.isShown === true) {
		try {
			com.inq.utils.Capabilities.UnbindListener(this.clientDocument,"touchmove",this.touchListener);
			com.inq.utils.Capabilities.UnbindListener(this.clientWindow,"orientationchange",this.orientationListener);
			com.inq.utils.Capabilities.UnbindListener(this.clientWindow, "resize", this.resizeListener);

			this.clientDocument.body.style.minHeight = "";
			if(this.restoreWidth == this.clientWidth && this.clientViewportContent && (com.inq.flash.client.chatskins.ChatTextFocusMonitor.closing || com.inq.flash.client.control.MinimizeManager.minimized)) {
				com.inq.utils.Timer.delay($bind(this, function(){this.RestoreViewport()}),100);
			} else {
				this.RestoreViewport();
			}

			if (com.inq.stage.ViewportMgr.impl.currentScroll) {
				this.clientLeftOffset = com.inq.stage.ViewportMgr.impl.currentScroll.X;
				this.clientTopOffset = com.inq.stage.ViewportMgr.impl.currentScroll.Y;
			}

			this.clientWindow.scrollTo(this.clientLeftOffset,this.clientTopOffset);
			this.isShown = false;
			/**
			 * We use this workaround, because in Application.js(setInitialSize) function ScrollToNearTop was called
			 * and pageXOffset, pageYOffset updated to 0,1. When we called onTouchStart, position for currScroll
			 * override too. In future, pageXOffset, pageYOffset and currScroll saving correct values. It's reason for
			 * update com.inq.stage.ViewportMgr.impl.currentScroll value
			 * */
			com.inq.stage.ViewportMgr.impl.currentScroll = null;
		} catch( er ) {
	        haxe.Log.trace("ViewportMgrImpStd._hide: ERROR:" + Std.string(er));
		}
	}
};


/**
 * calcPhoneWidth
 *
 * $type TFun([],TEnum(Void,[]))
 * private function calcPhoneWidth()
 * @private
 * @this com.inq.stage.ViewportMgrImplMobile
 * @return {void}
 */
com.inq.stage.ViewportMgrImplMobile.prototype.calcPhoneWidth = function() {
	if(this.phoneWidth == 0) {
		/* If we do NOT have the phone's device width, then
		 * we can get it by changing the viewport width to "device-width"
		 */
		this.modifyViewport("width=device-width");
		this.phoneWidth = window.top.document.documentElement.offsetWidth;
		this.adjustViewport();
	}
};


/**
 * _show
 *
 * @override
 * @private
 * @this com.inq.stage.ViewportMgrImplMobile
 * @return {void}
 */
com.inq.stage.ViewportMgrImplMobile.prototype.show = function() {
	if(this.isShown == false) {
		try {
			/** restoreWidth is already calculated in constructor. We should use that rather calculating it over here**/
			this.clientLeftOffset = this.clientWindow.pageXOffset;
			this.clientTopOffset = this.clientWindow.pageYOffset;

			this.clientDocument.body.style.minHeight = this.clientDocument.documentElement.offsetHeight + 1 + "px";

			/* We must unbind before bind to make sure we have no "extra" BindListener
			 * This can happen if "stage.visible(true)" is called more times than "stage.visible(false)
			 * This always happens after the second chat session on a page because
			 *  the IJSF in Chat.js calls visible(true) asyncronously, independently at the launch of the CI
			 *
			 *  FIX_ME
			 *  Your comment is not right because when isShown is set true, this function is not mean to be executed.
			 *  meaning this code is not executed until hide() is called.
			 *  A Great concern is that this listeners are fighting with ChatTextFocusMonitor's listener.
			 */
			com.inq.utils.Capabilities.BindListener(this.clientWindow, "resize", this.resizeListener);
			com.inq.utils.Capabilities.BindListener(this.clientWindow, "orientationchange", this.orientationListener);
			com.inq.utils.Capabilities.BindListener(this.clientDocument, "touchmove", this.touchListener);

			this.clientWidth = this.getInitialWidth();

			this.calcPhoneWidth();

			this.fixedWidthViewport();
			/* 	Application.initialZoom = innerWidth / phoneWidth; */
			Application.initialZoom = this.clientWindow.innerWidth / this.phoneWidth;
			/* Native app doesn't have address bar but has its own menu bar on top which is not in window.innerheight
			*  fixPositioning will break chat window size and put text input below bottom of screen */
			if (!com.inq.utils.Capabilities.isAndroidWebView() && !com.inq.utils.Capabilities.isIOSWebView()) {
				this.fixPositioning();
			}
			this.isShown = true;
		} catch (e) {
			com.inq.utils.Capabilities.UnbindListener(this.clientWindow, "resize", this.resizeListener);
			com.inq.utils.Capabilities.UnbindListener(this.clientWindow, "orientationchange", this.orientationListener);
			com.inq.utils.Capabilities.UnbindListener(this.clientDocument, "touchmove", this.touchListener);
			this.isShown = false;
		}
	}
};


/**
 * resizeChat
 *
 * @private
 * @this com.inq.stage.ViewportMgrImplMobile
 * @return {void}
 */
com.inq.stage.ViewportMgrImplMobile.prototype.resizeChat = function() {
	this.hide();
	this.phoneWidth = 0;/* Reset the phone width so it can be reevaluated */
	this.show();
	if (com.inq.utils.Capabilities.isIOSWebView()) {
		com.inq.flash.client.chatskins.ChatTextFocusMonitor.resizeToViewport();
	}
};


/**
 * adjustViewport
 *
 * reset viewport meta tag value according to zoom level
 *
 * TODO Comment how the meta tag contents are determined.
 *
 * @private
 * @this com.inq.stage.ViewportMgrImplMobile
 * @return {void}
 */
com.inq.stage.ViewportMgrImplMobile.prototype.adjustViewport = function() {
	/** @type {number} */ 
	var zoomLevel = 1;
	try {
		zoomLevel = this.phoneWidth / this.restoreWidth;
	} catch( e ) {
		haxe.Log.trace("error: " + Std.string(e),{ fileName : "ViewportMgrImplMobile.hx", lineNumber : 87, className : "com.inq.stage.ViewportMgrImplMobile", methodName : "adjustViewport"});
	}
	if(zoomLevel >= 0.25 && zoomLevel <= 5)
		this.modifyViewport("width=device-width, initial-scale=" + zoomLevel + ", minimum-scale=0.25, maximum-scale=5, user-scalable=yes");
	else {
		this.modifyViewport("width=" + this.restoreWidth + ", minimum-scale=0.25, maximum-scale=5, user-scalable=yes");
	}
};


/**
 * fixedWidthViewport
 *
 * reset viewport meta tag content value with com.inq.stage.ViewportMgrImplMobile.FIXED_CONTENT
 *
 * @private
 * @this com.inq.stage.ViewportMgrImplMobile
 * @return {void}
 */
com.inq.stage.ViewportMgrImplMobile.prototype.fixedWidthViewport = function() {
	if ((com.inq.utils.Capabilities.isSafariVersion9() ||
		com.inq.utils.Capabilities.isSafariVersion10()||
		com.inq.utils.Capabilities.isSafariVersion11() ||
		com.inq.utils.Capabilities.isSafariVersion12()) && com.inq.utils.Capabilities.isPhone()) {
		this.modifyViewport(com.inq.stage.ViewportMgrImplMobile.FIXED_CONTENT_IOS);
	} else {
		this.modifyViewport(com.inq.stage.ViewportMgrImplMobile.FIXED_CONTENT);
	}
};

/**
 * uponTouch
 *
 * Event handler prevents event bubble
 *
 * @public
 * @param {TouchEvent}  event
 * @return {void}
 */
com.inq.stage.ViewportMgrImplMobile.prototype.uponTouch = function(event) {
	// TODO this is shot solution to solve MOB-550
	if(com.inq.utils.Capabilities.isPhone()) {
		/* prevent event bubbling on iPhone */
		if (!com.inq.stage.ViewportMgr.impl || com.inq.stage.ViewportMgr.impl.zoomedScreenMsgIsVisible !== true) {
			event.preventDefault();
		}
	} else  if(event.touches.length == 2) {
		/* Only prevent if two fingers are being used to stop the pinch gesture */
		event.preventDefault();
	}
};

/**
 * uponOrientationChange
 *
 * TODO:  ChatTextFocusMonitor is also listening this event. Why duplicate?
 *
 * @public
 * @this com.inq.stage.ViewportMgrImplMobile
 * @param {js.Event}  event
 * @return {void}
 */
com.inq.stage.ViewportMgrImplMobile.prototype.uponOrientationChange = function(event) {
	if (com.inq.ui.Stage.getInstance().getVisible()) {
		/*
		 RTDEV-27081: Increase the delay from 50ms to 200ms, as chrome on iOS12 responds slower
		 during the orientation change event which results in incorrect "window.top.innerWidth"
		 size in the function getChatZoomLevel() and hence the incorrect zooming.
		*/
		com.inq.utils.Timer.delay($bind(this, this.resizeChat),200);
		/**
		 * This is to reset the scrolling positions after the orientation change
		 * @type {Array.<com.inq.ui.XFrame>}
		 */
		var xframes = Application.application.getXFrameItems();
		for(var i=0;i<xframes.length;i++) {
			xframes[i].resetScrolling();
		}
	}
	com.inq.utils.Capabilities.setOrigViewPortHeight();
};

/**
 * toggleZoomedScreenMsg
 *
 * 
 *
 * @public
 * @this com.inq.stage.ViewportMgrImplMobile
 * @return {void}
 */
com.inq.stage.ViewportMgrImplMobile.prototype.toggleZoomedScreenMsg = function() {
	if (com.inq.stage.ViewportMgr.impl == null) {
		com.inq.stage.ViewportMgr.init();
	}
	// get the canvas
	var canvas = Application.application.getCanvas(com.inq.stage.ViewportMgr.impl.zoomedScreenMsgId);
	// always initially hide
	if (canvas) {
		canvas.setVisible(false);
		// flag this instance as hidden
		com.inq.stage.ViewportMgr.impl.zoomedScreenMsgIsVisible = false;
	}

	// do not show in landscape orientation
	if (com.inq.utils.Capabilities.getOrientation() == 0) return;

	// only show on iOS10 if zoom > 1
	if (canvas && com.inq.utils.Capabilities.isPhone() && (com.inq.utils.Capabilities.isSafariVersion10() || com.inq.utils.Capabilities.isSafariVersion11() || com.inq.utils.Capabilities.isSafariVersion12()) && com.inq.utils.Capabilities.getZoom() > 1.1) {

		// show the overlay message
		canvas.setVisible(true);

		// scroll page to top left
		window.top.scrollTo(0, 0);

		// flag the message as shown on the current instance
		com.inq.stage.ViewportMgr.impl.zoomedScreenMsgIsVisible = true;

		// set the accessibility message
		var timer = new com.inq.utils.Timer(70 * "home button to the right".length + 3E3);
		var _aria = com.inq.aria.AriaMsg;
		_aria.clearAriaMsg();
		timer.run = function () {
			_aria.addAriaMsg("For a better chat experience, please zoom out.", com.inq.flash.client.chatskins.ChatTextArea.SYSTEM, true);
			timer.stop();
		};
	}
};


/** @private @type {Object} */
com.inq.stage.ViewportMgrImplMobile.prototype.orientationListener = null;
/** @private @type {Object} */
com.inq.stage.ViewportMgrImplMobile.prototype.resizeListener = null;
/** @private @type {Object} */
com.inq.stage.ViewportMgrImplMobile.prototype.touchListener = null;
/** @private @type {number} */
com.inq.stage.ViewportMgrImplMobile.prototype.restoreWidth = null;
/** @private @type {number} */
com.inq.stage.ViewportMgrImplMobile.prototype.phoneWidth = null;
/** @private @type {number} */
com.inq.stage.ViewportMgrImplMobile.prototype.clientTopOffset = null;
/** @private @type {number} */
com.inq.stage.ViewportMgrImplMobile.prototype.clientLeftOffset = null;
/** @private @type {number} */
com.inq.stage.ViewportMgrImplMobile.prototype.clientWidth = null;
/** @private @type {js.Document} */
com.inq.stage.ViewportMgrImplMobile.prototype.clientDocument = null;
/** @private @type {js.Window} */
com.inq.stage.ViewportMgrImplMobile.prototype.clientWindow = null;
/** @private @type {js.HtmlDom} */
com.inq.stage.ViewportMgrImplMobile.prototype.chatViewportClient = null;
/** @private @type {js.HtmlDom} */
com.inq.stage.ViewportMgrImplMobile.prototype.chatViewportElement = null;
/** @private @type {string} */
com.inq.stage.ViewportMgrImplMobile.prototype.clientViewportContent = null;
/** @private @type {js.HtmlDom} */
com.inq.stage.ViewportMgrImplMobile.prototype.clientViewportElement = null;
/** @private @type {js.HtmlDom} */
com.inq.stage.ViewportMgrImplMobile.prototype.headHtml = null;
/** @private @type {boolean} */
com.inq.stage.ViewportMgrImplMobile.prototype.zoomedScreenMsgIsVisible = false;
/** @private @type {string} */
com.inq.stage.ViewportMgrImplMobile.prototype.zoomedScreenMsgId = "zoomedScreenMsg";

/** @const */
com.inq.stage.ViewportMgrImplMobile.DEFAULT_CONTENT = "width=device-width, minimum-scale=1, maximum-scale=1, user-scalable=yes";
/** @const */
com.inq.stage.ViewportMgrImplMobile.FIXED_CONTENT = "width=device-width, minimum-scale=1.0, initial-scale=1.0, maximum-scale=1.0, user-scalable=yes";
com.inq.stage.ViewportMgrImplMobile.FIXED_CONTENT_IOS = "width=device-width, minimum-scale=1.0, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, shrink-to-fit=no";


/** @type {com.inq.stage.ViewportMgrImplMobile} */
com.inq.stage.ViewportMgrImplMobile.prototype.__class__ = com.inq.stage.ViewportMgrImplMobile;
